import XLSX from 'xlsx'
import { Message } from 'element-ui'
import axios from 'axios'
import FileSaver from 'file-saver'

import Worker from './file.worker.js'

const prefixUrl = process.env.NODE_ENV === 'production' ? '/' : '/'
// 并发请求
export async function concurrencyReq(total, par, request, resk = 'data') {
  if (total == 0) {
    return []
  }
  // 分流量
  const size = 8000
  // 分片（需要循环几次）
  const step = Math.ceil(total / size)
  // 目标数组
  const res = []
  for (let i = 1; i <= step; i++) {
    const params = {
      page: i,
      pagesize: size,
      ...par
    }
    res.push(request(params))
  }
  const allr = await Promise.all(res)
  const data = allr.reduce((pre, cur) => {
    // 如果是数组类型直接push(sap返回数据格式)
    if (cur[resk] instanceof Array) {
      pre.push(...cur[resk])
    } else { // java 查询返回数据结构
      pre.push(...cur[resk].Rows)
    }
    return pre
  }, [])
  return Promise.resolve(data)
}

/**
 * 前端导出Excel文件
 * @param {*} columns 表头
 * @param {*} datas 表格数据
 * @param {*} fileName 导出文件名称
 * @param {*} fileType 导出文件格式 1 xlsx 2 csv
 */
export function frontExport(columns, datas, fileName, fileType = 1) {
  if (!datas.length) {
    return Message.warning('没有数据可以导出！')
  }
  const notTypeColumns = columns.filter(v => !v.type)
  // 表格头部
  const headerRowTitle = notTypeColumns.map(v => v.title)
  // 头部对应的字段名称(field)
  const headerRowField = notTypeColumns.map(v => v.field)
  const xlsxFmt = notTypeColumns.map(v => {
    return {
      ...v.xlsxFmt,
      z: v?.xlsxFmt?.z || (v?.xlsxFmt?.t === 'n' ? '0.000' : ''),
      width: (typeof v.width === 'string' ? 120 : (v.width || 120)) - 20
    }
  })

  console.log(xlsxFmt, 'xlsxFmt')

  const worker = new Worker()

  // 给子线程发送数据
  worker.postMessage(
    {
      headerRowTitle,
      headerRowField,
      xlsxFmt,
      datas: datas,
      fileName
    }
  )
  // 子线程处理完成之后的数据，直接下载
  worker.addEventListener('message', e => {
    console.log(e.data, '子线程返回的数据')
    FileSaver.saveAs(e.data.xlsxBlob, fileName + '.xlsx')
  })
}

/**
 * 数据转换
 * @param {*} data 需要转换的数据
 * @param {*} cl 列
 * @param {*} zn 表头
 * @param {*} type 导出文件类型 1 xlsx 0 csv
 */
export async function transferData(data, cl, zn, type) {
  try {
  // 分流量
    const size = 1000
    // 分片（需要循环几次）
    const step = Math.ceil(data.length / size)
    // 目标数组
    const res = []
    // csv 每行为 列1,列2,列三\n 的纯文本文件。所以这里需要拼接一下
    type === 1 ? res.push(zn) : res.push(zn.toString() + '\n')
    data.forEach(item => {
      const arr = []
      cl.forEach(key => {
        // 去字符串中的掉值里面的换行符
        if (item[key] && (typeof item[key] === 'string')) {
          item[key] = item[key].replaceAll(',', '，').replaceAll(' ', '')
          // 如果有换行符替换成空
          if (item[key]?.indexOf('\n') > -1) {
            item[key] = item[key].replaceAll(/[\r\n]/g, '')
          }
        }
        if (/^\d+(.\d+)?[-]$/.test(item[key])) { // 去掉在数字后面的负号
          item[key] = item[key].replace('-', '')
          item[key] = '-' + item[key]
        } else if (/^\d{10}/.test(item[key])) { // 如果是数字添加文本格式，防止csv导出之后数字超出10位变成科学计算
          item[key] = '\t' + item[key]
        }
        // 转换成数字类型
        if (!isNaN(item[key]) && !!item[key] && item[key] < 1000000000 && !(/^[0]+/.test(item[key]))) {
          item[key] = Number(item[key])
        }
        arr.push(item[key])
      })
      type === 1 ? res.push(arr) : res.push(arr.toString() + '\n')
    })
    // // 遍历分片
    // for (let i = 0; i < step; i++) {
    //   // 获取分片对应的数据
    //   const datas = data.slice(i * size, (i + 1) * size)
    //   // 格式化内容
    //   datas.forEach(item => {
    //     const arr = []
    //     cl.forEach(key => {
    //       arr.push(item[key])
    //     })
    //     type === 1 ? res.push(arr) : res.push(arr.toString() + '\n')
    //   })
    // }
    return res
  } catch (e) {
    return Promise.reject(e)
  }
}

/**
 * 导出全部
 * @param {*} request axios 请求
 * @param {*} params axios 请求参数
 * @param {*} options columns、resk（返回结果的key）、fileName
 */
export function exportAll(request, params, options) {
  params.pagesize = params.totalCount
  params.page = 1
  request(params).then(res => {
    if (res[options.resk].length) {
      frontExport(options.columns, res[options.resk || 'data'], options.fileName || `export_${new Date().toLocaleDateString().replaceAll('\/', '')}`)
    } else {
      return Message.warning('导出失败！')
    }
  }).catch(() => {
    return Message.warning('导出失败！')
  })
}

// 16 进制字符串转换成整型数组
export const hexToBytes = (hexStr) => {
  var bytes = []
  for (var c = 0; c < hexStr.length; c += 2) { bytes.push(parseInt(hexStr.substr(c, 2), 16)) }
  return bytes
}

export const sapDownloadFile = (res, filename) => {
// 调用服务端方法，取得 16 进制字符串 res
  var uint8Array = new Uint8Array(hexToBytes(res))
  var blob = new Blob([uint8Array], { type: 'application/octet-stream' })

  // 兼容 IE、火狐和谷歌的下载方式
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    var downloadElement = document.createElement('a')
    var href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = filename
    document.body.appendChild(downloadElement)
    downloadElement.click()
    downloadElement.remove()
    window.URL.revokeObjectURL(href)
  }
}

export function download(data, fileName, responseType = 'application/octet-stream') {
  const blob = data instanceof Blob ? data : new Blob([data], { type: responseType })
  if ('download' in document.createElement('a')) { // 非IE下载
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName || (new Date().getTime()))
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(link.href)
    document.body.removeChild(link)
  } else { // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}

export function downloadLocalFile(file, fileName) {
  const a = document.createElement('a')
  const src = prefixUrl + 'static/downloadLocalFile/' + file
  axios.get(src, { responseType: 'blob' }).then(res => {
    const url = URL.createObjectURL(new Blob([res.data]))
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(a.href)
    document.body.removeChild(a)
  })
  // a.download = fileName
  // a.click()
  // a.remove()
}



// WEBPACK FOOTER //
// ./src/utils/frontExport.js